module.exports = __webpack_public_path__ + "static/patsch-644619f336c49b59f91b494b0afaaac2.jpg";